import { defineMessage } from "react-intl";

/* Tri */
export const ENVIRONMENTS_SORT_VALUE_CREATED_ASC = "created_asc";
export const ENVIRONMENTS_SORT_VALUE_CREATED_DESC = "created_desc";
export const ENVIRONMENTS_SORT_VALUE_NAME_ASC = "name_asc";
export const ENVIRONMENTS_SORT_VALUE_NAME_DESC = "name_desc";

export const ENVIRONMENTS_SORT_MESSAGE = defineMessage({
  id: "raiden.library.constants.environments.sort",
  defaultMessage:
    "{sort, select, created_asc {Date de création croissante} created_desc {Date de création décroissante} name_asc {Nom croissant} name_desc {Nom décroissant} other {{sort}}}",
});

export const ENVIRONMENTS_SORTS = {
  [ENVIRONMENTS_SORT_VALUE_CREATED_ASC]: {
    id: ENVIRONMENTS_SORT_VALUE_CREATED_ASC,
  },
  [ENVIRONMENTS_SORT_VALUE_CREATED_DESC]: {
    id: ENVIRONMENTS_SORT_VALUE_CREATED_DESC,
  },
  [ENVIRONMENTS_SORT_VALUE_NAME_ASC]: {
    id: ENVIRONMENTS_SORT_VALUE_NAME_ASC,
  },
  [ENVIRONMENTS_SORT_VALUE_NAME_DESC]: {
    id: ENVIRONMENTS_SORT_VALUE_NAME_DESC,
  },
};

export const ENVIRONMENTS_SORT_LIST = Object.values(ENVIRONMENTS_SORTS);

/* Quotas types */
export const ENVIRONMENTS_QUOTAS_TYPE_VALUE_SMS = "sms";
export const ENVIRONMENTS_QUOTAS_TYPE_VALUE_EMAIL = "email";

export const ENVIRONMENTS_QUOTAS_TYPE_MESSAGE = defineMessage({
  defaultMessage: "{type, select, sms {SMS} email {E-mail} other {{type}}}",
});

export const ENVIRONMENTS_QUOTAS_TYPES_COUNT_MESSAGE = defineMessage({
  defaultMessage:
    "{type, select, sms {Nombre de SMS} email {Nombre d’e-mail} other {{type}}}",
});

export const ENVIRONMENTS_QUOTAS_TYPES = {
  [ENVIRONMENTS_QUOTAS_TYPE_VALUE_SMS]: {
    id: ENVIRONMENTS_QUOTAS_TYPE_VALUE_SMS,
  },
  [ENVIRONMENTS_QUOTAS_TYPE_VALUE_EMAIL]: {
    id: ENVIRONMENTS_QUOTAS_TYPE_VALUE_EMAIL,
  },
};

export const ENVIRONMENTS_QUOTAS_TYPE_LIST = Object.values(
  ENVIRONMENTS_QUOTAS_TYPES,
);

/** @type {number} */
export const DEFAULT_ENVIRONMENT_ID = 1;
